import { render, staticRenderFns } from "./BetaGate.vue?vue&type=template&id=480d52b4&scoped=true"
import script from "./BetaGate.vue?vue&type=script&lang=js"
export * from "./BetaGate.vue?vue&type=script&lang=js"
import style0 from "./BetaGate.vue?vue&type=style&index=0&id=480d52b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d52b4",
  null
  
)

export default component.exports